module.exports = __webpack_public_path__ + "static/img/1.c7e07fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutUs/zlgl/1.jpg
// module id = WiwJ
// module chunks = 0